import { Component, OnInit, Inject, ElementRef, ViewChild, AfterViewInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { OreConstants } from '../../../../../core/_shared/uf-list';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';


export interface PurchasesSearchDialogData {
  headerOption: string;
  searchText: string;
  status:number; 
  companyId:number;
  productId:number;
  onlyIncomplete:boolean;
}

@Component({
  selector: 'app-purchases-search-dialog',
  templateUrl: './purchases-search-dialog.component.html',
  styleUrls: ['./purchases-search-dialog.component.css']
})
export class PurchasesSearchDialogComponent implements OnInit {

  _searchForm: UntypedFormGroup;
  public purchaseStatus:any[]; 
  public options = [{id:-1,name:'Todos'}];
  
  @ViewChild('searchText',{static:true}) searchText: ElementRef;

  constructor(
    public dialogRef: MatDialogRef<PurchasesSearchDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: PurchasesSearchDialogData,
    private formBuilder:UntypedFormBuilder) { 

      this.purchaseStatus = OreConstants.getPurchaseStatus();

      this.purchaseStatus.push({id:-1,name:"Todos"});
      this._searchForm = this.formBuilder.group(data);
    }

  onNoClick(): void {

  
    this.dialogRef.close();
  }

  closeDialog(): void {

 

    console.log(this._searchForm.value);
  
   this.dialogRef.close(this._searchForm.value);
  }


  changeFire(evewnto)
  {
    console.log(this._searchForm.value);
  }
  ngOnInit() {
  }



}


